export default __webpack_public_path__ + "media/images/icons/portfolio-outline-8e23538e038334a487fe8dcb7219bc8f.png";